module.exports = __webpack_public_path__ + "static/secure-fa41526a5ab6fd413729fe43d729da9e.png";